// TOP LEVEL IMPORTS
import gql from 'graphql-tag';
import organizationFragment from 'ApolloClient/Fragments/organizationFragment';

export default gql`
  query orgById($_id: ID!) {
    orgById(_id: $_id) {
      ...organizationFragment
    }
  }
  ${organizationFragment}
`;



// WEBPACK FOOTER //
// ./src/ApolloClient/Queries/orgById.js